// ############################################################################
// ## MISC ####################################################################
// ############################################################################

import $ from "jquery"
import {$doc} from "./_globals.js";
import {AJAX} from "./ajax";
import {exitFullscreen} from "./utils";

// on document ready
$(function () {
  // submenu collapsing
  $(".sidebar-submenu").prev("a").click(function (evt) {
    var $el = $(this);
    $el.parent().toggleClass("active").siblings().removeClass("active");
    evt.preventDefault();
  });
});




// checkable table rows
export function updateTableCheckbox(el) {
  $(el).closest("tr").toggleClass("table-active", el.checked);
}

$doc.on("change", "input[type=checkbox][data-toggle-tr]", function () {
  updateTableCheckbox(this);
});

function updateTableCheckboxes () {
  $("input[type=checkbox][data-toggle-tr]").each(function () {
    updateTableCheckbox(this);
  });
}

$(updateTableCheckboxes);
AJAX.onUpdate(updateTableCheckboxes);




// Modal autofocus
$doc.on("shown.bs.modal", function($evt) {
  const $focusEls = $($evt.target).find("[data-focus]").eq(0);
  $focusEls.focus();
  if ($.fn.tooltip) $focusEls.tooltip("hide");
  if ($.fn.popover) $focusEls.popover("hide");
});






// checkbox reset buttons
{
  const ATTR = "data-toggle-checkboxes";

  $doc.on("click", "["+ATTR+"]", function() {
    const $this = $(this);
    const $checkboxes = $this.closest(":has(:checkbox)").find(":checkbox");

    if(!$checkboxes.length) return;

    const mode = $this.attr(ATTR);

    switch(mode) {
      case "off":
        $checkboxes.prop("checked", false);
        break;
      case "on":
        $checkboxes.prop("checked", true);
        break;
      default:
        const checked = $checkboxes.get().some(cb => cb.checked);
        $checkboxes.prop("checked", !checked);
    }
  });
}



// :invalid support in jQuery
$.extend($.expr[':'], {
  invalid : function(elem, index, match){
    var invalids = document.querySelectorAll(':invalid');
    var len = invalids.length;

    for (var i=0; i<len; i++) {
      if (elem === invalids[i]) return true;
    }

    return false;
  }
});






// data-toggle=collapse-next
$doc.on('click.collapse-next.data-api', '[data-toggle=collapse-next]', function () {
  var $btn = $(this).closest('[data-toggle=collapse-next]');
  var $target = $btn.next();
  var parentSel = $btn.attr("data-parent");

  if (parentSel) {
    var $parent = $btn.closest(parentSel);
    $parent.find('[data-toggle=collapse-next]').not($btn).attr("aria-expanded", "false").next().collapse("hide");
  }

  $btn.attr("aria-expanded", $btn.attr("aria-expanded") === "true" ? "false" : "true");
  $target.collapse('toggle');
});





if(!window.onunload) window.onunload = function() {}; // prevent FF from not running scripts when navigating back in history






// double form submission prevention
$doc.on("submit", "[data-prevent-double-submission]", function($evt) {
  var $this = $(this);
  // var submitter = $evt.originalEvent.submitter;
  var $btns = /*submitter ? $(submitter) : */$this.find("button[type=submit],button:not([type]),input[type=submit]");

  setTimeout(function() {
    $btns.prop("disabled", true);
    $this.on("submit", function($evt) {
      console.warn("Prevented double submission");
      $evt.preventDefault();
    });
  }, 0);
});





// linkable tabs
/*$(document).on("show.bs.tab", ".js-tabs-linkable", function($evt) {
  history.replaceState(null, "", $evt.target.href);
}).ready(function() {
  $(`.js-tabs-linkable [href='${location.hash}']`).tab("show");
});*/





// .js-scroll-animated
$doc.on("click", ".js-scroll-animated", $evt => {
  const $btn = $($evt.target);
  const href = $btn.attr("href");
  if (!href || href[0] !== "#") return;
  const $target = $(href);
  if (!$target.length) return;
  $('html, body').animate({ scrollTop: $target.offset().top },  { duration: 600 });
  $evt.preventDefault();
});




// exit fullscreen when modal is shown
$doc.on("show.bs.modal", exitFullscreen);

// Sam rika, ze target="_blank" jinak nefunguje
$doc.on("click", "a[target='_blank']", $evt => {
  const url = $evt.currentTarget.href;
  if (url) {
    window.open(url, "_blank");
    $evt.preventDefault();
  }
});
